import { get } from 'lodash-es'

import { request } from '@/common/utils/request'

export default {
  fetchBizoppNameSug: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getNameSug',
      ...params
    })
  },

  bizoppUpdateTags: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.updateTags',
      params: params
    })
  },
  /*
   * 根据POI选择城市
   */
  getCityIdByPoi: params => {
    return request.get({
      url: 'crm.bdapp.index.common.getCityIdByPoi',
      params: params
    })
  },
  /*
   * 根据国家选择品类
   */
  getCategoryByCountry: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getCategoryByCountry',
      params: params
    })
  },

  add: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.addApply',
      ...params
    })
  },

  update: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.update',
      ...params
    })
  },

  getBizoppInfo: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getBizoppInfo',
      ...params
    })
  },

  getMyFaildeBizoppInfo: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getApplyBizoppInfo',
      params: params
    })
  },

  /**
   * sign 签约部分
   */

  getContractInfo: data =>
    request.post({
      url: 'crm.bdapp.open.apply.get',
      data
    }),
    
  getCommonApplyBaseInfo (params) {
    return request.get({
      url: 'crm.bizopp.bizopp.getCommonApplyBaseInfo',
      params
    })
  },
  getSignAudit: data =>
    request.post({
      url: 'crm.bdapp.open.apply.get',
      data
    }),

  getSignShopAudit: data => {
    return request
      .post({
        url: 'crm.bdapp.open.apply.get',
        data
      })
      .then(res => {
        return get(res, 'data.auditGlobal', {})
      })
  },

  getCommonConfig: params => {
    return request
      .get({
        url: 'crm.common.getConfig',
        params
      })
  },
  /**
   * sign 主体签约部分
   */
  //=================================================
  //根据shopId获取关联主体的信息
  getSignInfoByShopId: data => {
    return request
      .post({
        url: 'crm.sign.apply.getSignInfoByShopId',
        data
      })
  },
  // 根据shopId创建新主体
  createContractorByShopId: data => {
    return request
      .post({
        url: 'crm.sign.apply.createContractorByShopId',
        data
      })
  },
  // 根据主体配置签约方式
  setContractSignType: data => {
    return request
      .post({
        url: 'crm.open.apply.setContractSignType',
        data
      })
  },
  // 获取主体详情
  getSignDetail: data => {
    return request
      .post({
        url: 'crm.contractor.apply.get',
        data
      })
  },
  // 更新主体信息
  saveSignDetail: data =>{
    return request.post({
      url: 'crm.contractor.apply.update',
      data
   })
  },
  //获取主体关联的门店信息
  getSignRelationShopList: params=>{
    return request.get({
      url: 'crm.contractor.apply.getBindShop',
      params
    })
  },
  //提交至审批
  submitSignDetail: data=>{
    return request.post({
      url: 'crm.contractor.apply.submitGlobal',
      data
    })
  }
}

